<template>
	<div class="Search">
		<TopMenu :isShow="true"></TopMenu>
		<div class="videoBox">
			<div class="contentStyle">
				<div class="styleHeader">
					<div class="headerBox">
						<span class="headerTitle">全部</span>
					</div>
				</div>
				<div class="videoListSBox">
					<div class="itemSBox" v-for="(item,index) in searchData" :key="index">
						<div class="imgSBox" @mouseenter="hotMouseEnter($event,index)">
							<img :src="item.CoverUrlPortrait" alt="">
							<div class="timeNumBox">
								{{item.Duration}}
								<div class="numBox">
									{{item.Clicks}}次播放
								</div>
							</div>
						</div>
						<div class="infoSBox">
							<div class="videoTitle" @click="naviToHotDetails(item.VId)">
								{{item.Title}}
							</div>
							<div class="videoSubTitle">
								{{item.Intro}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Pagination :config="pageConfig" @currentPage="handCurrenPage" v-if="searchData.length"></Pagination>
		<BottomMenu></BottomMenu>
		<div class="loading" v-if="isLoading">
			<img src="https://img.alicdn.com/tfs/TB1qa_fdQL0gK0jSZFtXXXQCXXa-88-88.gif" alt="">
		</div>
		<PopMenu :popX="popX" :popY="popY" :isPop="isPop" @changeIsPop="changeIsPop" @naviToDetails="naviToHotDetails"
			:curReCommand="curReCommand">
		</PopMenu>
	</div>
</template>

<script>
	import TopMenu from '../components/topMenu'
	import BottomMenu from '../components/bottomMenu'
	import Pagination from '../components/pagination'
	import PopMenu from '../components/popMenu'
	export default {
		name: 'Search',
		components: {
			TopMenu,
			BottomMenu,
			Pagination,
			PopMenu
		},
		data() {
			return {
				page: 1,
				popX: 0,
				popY: 0,
				isPop: false,
				isLoading: false,
				screenWidth: 0,
				columnsNum: 0,
				searchData: [],
				curReCommand: {},
				pageConfig: {
					total: 0,
					pageSize: 15,
				}
			}
		},
		created() {
			this.screenWidth = document.body.clientWidth
			window.onresize = () => {
				return (() => {
					this.screenWidth = document.body.clientWidth
				})()
			}
		},
		watch: {
			screenWidth: {
				handler: function(val, oldVal) {
					if (val <= 1279) {
						this.columnsNum = 4
					} else if (val <= 1599) {
						this.columnsNum = 5
					} else if (val <= 1899) {
						this.columnsNum = 6
					} else {
						this.columnsNum = 7
					}
				},
			},
		},
		mounted() {
			this.getVlogSearchVideoList()
		},
		methods: {
			//视频搜索
			getVlogSearchVideoList() {
				this.isLoading = true
				this.$api.post('/VideoNew/getVlogSearchVideoList?page=' + this.page ,{
					key: this.$route.query.keyWord,
				}).then(res => {
					if (res.code == 200) {
						this.pageConfig.total = res.data.total
						this.searchData = res.data.data
						this.isLoading = false
					}
				}).catch(err => {
					console.log(err);
				})
			},
			hotMouseEnter(e, index) {
				this.curReCommand = this.searchData[index]
				this.isPop = true
				if (index % this.columnsNum == 0) {
					this.popX = e.target.offsetLeft
				} else if (index % this.columnsNum == this.columnsNum - 1) {
					this.popX = e.target.offsetLeft - (394 - e.target.offsetWidth)
				} else {
					this.popX = e.target.offsetLeft - (394 - e.target.offsetWidth) / 2
				}
				this.popY = e.target.offsetTop - (440 - e.target.offsetHeight - 50) / 2
			},
			//详情
			naviToHotDetails(videoId) {
				let routeData = this.$router.resolve({ path: '/Details',query: {videoId: videoId}});
				window.open(routeData.href, '_blank');
			},
			changeIsPop(isShow) {
				this.isPop = isShow
			},
			handCurrenPage(curPage) {
				this.page = curPage
				this.getVlogSearchVideoList()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.videoBox {
		margin-top: 70px;
		margin-left: 226px;
		margin-right: 188px;
	}
	
	.loading {
		position: absolute;
		left: calc(50% - 22px);
		top: 70px;
	
		img {
			width: 44px;
			height: 44px;
		}
	}
	
	.contentStyle {
		color: rgba(255, 255, 255, 0.87);

		.styleHeader {
			display: flex;
			align-items: baseline;
			justify-content: space-between;

			.headerBox {
				margin: 0px 0px 10px;
				height: 50px;
				line-height: 50px;

				.headerTitle {
					font-size: 24px;
					font-weight: 500;
					text-align: left;
					cursor: auto;
				}
			}
		}

		.videoListSBox {
			display: flex;
			flex-wrap: wrap;

			.itemSBox {
				padding-right: 12px;
				box-sizing: border-box;
				margin-bottom: 60px;

				.imgSBox {
					border-radius: 10px 10px 0px 0px;
					background: #25252b;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.timeNumBox {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						height: 26px;
						line-height: 26px;
						background: rgba(4, 4, 4, .29);
						position: absolute;
						bottom: 0px;
						left: 0px;
						text-align: right;
						padding: 0px 12px;
						box-sizing: border-box;
						font-size: 12px;
						font-weight: 400;
						color: #FAF7F7;
					}
				}

				.infoSBox {
					padding-top: 10px;

					.videoTitle {
						height: 22px;
						width: 100%;
						line-height: 22px;
						font-size: 16px;
						font-weight: 500;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-word;
						cursor: pointer;
					}

					.videoTitle:hover {
						color: #4ae3fa;
					}

					.videoSubTitle {
						color: rgba(255, 255, 255, 0.5);
						margin-top: 3px;
						height: 14px;
						line-height: 14px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.adBox {
			height: 100px;
			width: calc(100vw - 414px);
			margin-bottom: 40px;
			border-radius: 4px;
			overflow: hidden;
			position: relative;
			cursor: pointer;

			img {
				width: 100%;
				height: 100%;
			}

			.adTipBox {
				position: absolute;
				height: 18px;
				right: 8px;
				top: 0px;
				font-size: 12px;
				line-height: 18px;
				text-align: center;
				padding: 0px 4px;
				background: rgba(0, 0, 0, .6);
			}
		}
	}

	@media (max-width: 1099px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((1100px - 414px) / 4);

			.imgBox {
				height: calc((1100px - 414px) / 4 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((1100px - 414px) / 4 * 2);

			.imgTBox {
				height: calc((1100px - 414px) / 4 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((1100px - 414px) / 4);

			.imgSBox {
				height: calc((1100px - 414px) / 4 * 1.333);
			}
		}
	}

	@media (min-width: 1100px) and (max-width:1279px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 414px) / 4);

			.imgBox {
				height: calc((100vw - 414px) / 4 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 414px) / 4 * 2);

			.imgTBox {
				height: calc((100vw - 414px) / 4 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 414px) / 4);

			.imgSBox {
				height: calc((100vw - 414px) / 4 * 1.333);
			}
		}
	}

	@media (min-width: 1280px) and (max-width:1599px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 414px) / 5);

			.imgBox {
				height: calc((100vw - 414px) / 5 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 414px) / 5 * 2);

			.imgTBox {
				height: calc((100vw - 414px) / 5 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 414px) / 5);

			.imgSBox {
				height: calc((100vw - 414px) / 5 * 1.333);
			}
		}
	}

	@media (min-width: 1600px) and (max-width:1899px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 414px) / 6);

			.imgBox {
				height: calc((100vw - 414px) / 6 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 414px) / 6 * 2);

			.imgTBox {
				height: calc((100vw - 414px) / 6 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 414px) / 6);

			.imgSBox {
				height: calc((100vw - 414px) / 6 * 1.333);
			}
		}
	}

	@media (min-width: 1900px) {
		.contentStyle .videoListBox .itemBox {
			width: calc((100vw - 414px) / 7);

			.imgBox {
				height: calc((100vw - 414px) / 7 / 1.794);
			}
		}

		.contentStyle .videoListTBox .itemTBox {
			width: calc((100vw - 414px) / 7 * 2);

			.imgTBox {
				height: calc((100vw - 414px) / 7 * 2 / 1.794);
			}
		}

		.contentStyle .videoListSBox .itemSBox {
			width: calc((100vw - 414px) / 7);

			.imgSBox {
				height: calc((100vw - 414px) / 7 * 1.333);
			}
		}
	}
</style>